// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3YqLm","col":"styles_col__xa8vk","fulfillmentStatus":"styles_fulfillmentStatus__147fb","emailCol":"styles_emailCol__3ioS-"};